// @flow

const defaultMetrics = {
    marginHorizontal: '10px',
    marginVertical: '10px',
    padding: '20px',
    section: '25px',
    baseMargin: '10px',
    doubleBaseMargin: '20px',
    smallMargin: '5px',
    noMargin: '0px',
    noPadding: '0px',
    doubleSection: '50px',
    horizontalLineHeight: '1px',
    searchBarHeight: '30px',
    buttonRadius: '4px',
    cardRadius: '5px',
    breakHeight: '125px',
    icons: {
        tiny: '15px',
        small: '20px',
        medium: '30px',
        large: '45px',
        xl: '50px'
    },
    images: {
        small: '20px',
        medium: '40px',
        large: '60px',
        logo: '200px',
        avatar: '54px'
    }
};

const menuMetrics = {
    width: '256px',
    collapsedWidth: '64px',
    marginTop: '-4px',
    lineHeight: '63px',
    elementHeight: '20px',
    elementWidth: '30px',
    elementMargin: '0px',
    userElementMargin: '10px',
    userIconRadius: '50%',
    labelPosition: '2px',
    fontSize: '12.5px',
    fontWeight: 'bold',
    submenuIndent: '35px',
    submenuCollapsedIndent: '5px'
};

const containerMetrics = {
    margin: '24px',
    halfMargin: '12px',
    padding: '24px',
    halfPadding: '12px',
    minHeight: '500px',
    maxHeight: '500px'
};

const listMetrics = {
    minHeight: '30px'
};

const headerMetrics = {
    scrollTopToHide: 300,
    zIndex: 950,
    containerHeight: '64px',
    marginLeft: '20px',
    marginBottom: '15px',
    toggleBtnMarginLeft: '8px',
    productTitleFontSize: '18px',
    productTitleMarginLeft: '18px',
    productTitleMarginTop: '1px',
    mainTitlePaddingHorizontal: '24px',
    shadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)'
};

const footerMetrics = {
    paddingTop: '20px',
    paddingHorizontal: '25px',
    paddingBottom: '30px'
};

const logoMetrics = {
    containerHeight: headerMetrics.containerHeight,
    containerMarginBottom: '20px',
    logoWidth: '40px',
    logoHeight: '40px',
    logoTextHeight: '32px',
    logoMargin: '0 16px 0 12px',
    logoTextFontSize: '18px'
};

const productIconMetrics = {
    height: '20px',
    width: '20px',
    marginLeft: '2px',
    marginRight: '14px'
};

const antdMetrics = {
    FIRST: '8px',
    SECOND: '16px',
    THIRD: '24px',
    FOURTH: '32px',
    FIFTH: '40px',
    SIXTH: '48px'
};

const validationMetrics = {
    paddingTop: '10px'
};

const tabsMetrics = {
    paddingVertical: '30px',
    paddingHorizontal: '20px',
    titlePaddingRight: '10px',
    titlePaddingBottom: '5px'
};

export default {
    defaultMetrics,
    menuMetrics,
    containerMetrics,
    listMetrics,
    headerMetrics,
    footerMetrics,
    logoMetrics,
    productIconMetrics,
    antdMetrics,
    validationMetrics,
    tabsMetrics
};
